import { render } from "./TicketChatLogs.vue?vue&type=template&id=e5f2de10&scoped=true"
import script from "./TicketChatLogs.vue?vue&type=script&lang=js"
export * from "./TicketChatLogs.vue?vue&type=script&lang=js"

import "./TicketChatLogs.vue?vue&type=style&index=0&id=e5f2de10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f2de10"]])

export default __exports__